import { BaseURL } from "./UserApi"

export const AdminLoginApi = BaseURL + 'admin/adminLogin' // Admin Login (POST)
export const AdminChangePasswordApi = BaseURL + 'admin/changePassword' // Admin Change Password (PUT)

// ###### MASTERS API ########
// ===== User Type Master =====
export const GetUserTypeData = BaseURL + 'master/getUserTypeMasterList' // Get User Type Data (GET)
export const CreateUserTypeData = BaseURL + 'master/saveUserTypeMaster' // Create User Type Data (POST)
export const UpdateUserTypeData = BaseURL + 'master/updateUserTypeMaster' // Update User Type Data (PUT)
export const DeleteUserTypeData = BaseURL + 'master/deleteUserTypeMaster' // Delete User Type Data (DELETE) (params => ?id=2)

// ===== Slot Master =====
export const GetSlotData = BaseURL + 'master/getSlotMasterList' // Get Slot Data (GET)
export const CreateSlotData = BaseURL + 'master/saveSlotMaster' // Create Slot Data (POST)
export const UpdateSlotData = BaseURL + 'master/updateSlotMaster' // Update Slot Data (PUT)
export const DeleteSlotData = BaseURL + 'master/deleteSlotMaster' // Delete Slot Data (DELETE) (params => ?id=2)

// ===== Terms Condition Master =====
export const GetTermsConditionData = BaseURL + 'master/getTermsAndConditionMasterList' // Get TermsCondition Data (GET)
export const CreateTermsConditionData = BaseURL + 'master/saveTermsAndConditionMaster' // Create TermsCondition Data (POST)
export const UpdateTermsConditionData = BaseURL + 'master/updateTermsAndConditionMaster' // Update TermsCondition Data (PUT)
export const DeleteTermsConditionData = BaseURL + 'master/deleteTermsAndConditionMaster' // Delete TermsCondition Data (DELETE) (params => ?id=2)

// ===== Employee Master =====
export const GetEmployeeData = BaseURL + 'master/getEmployeeMasterList' // Get Employee Data (GET)
export const CreateEmployeeData = BaseURL + 'master/saveEmployeeMaster' // Create Employee Data (POST)
export const UpdateEmployeeData = BaseURL + 'master/updateEmployeeMaster' // Update Employee Data (PUT)
export const DeleteEmployeeData = BaseURL + 'master/deleteEmployeeMaster' // Delete Employee Data (DELETE) (params => ?id=2)

// ===== Fee Master =====
export const GetFeeData = BaseURL + 'master/getFeeMasterList' // Get Fee Data (GET)
export const CreateFeeData = BaseURL + 'master/saveFeeMaster' // Create Fee Data (POST)
export const UpdateFeeData = BaseURL + 'master/updateFeeMaster' // Update Fee Data (PUT)
export const DeleteFeeData = BaseURL + 'master/deleteFeeMaster' // Delete Fee Data (DELETE) (params => ?id=2)

// ===== LifeTimeMember Master =====

export const GetLifeTimeMemberData = BaseURL + 'user/getLifeTimeMembershipMasterList' // Get LifeTimeMember Data (GET)
export const CreateLifeTimeMemberData = BaseURL + 'user/saveLifeTimeMembershipMaster' // Create LifeTimeMember Data (POST)
export const UpdateLifeTimeMemberData = BaseURL + 'user/updateLifeTimeMembershipMaster' // Update LifeTimeMember Data (PUT)
export const DeleteLifeTimeMemberData = BaseURL + 'user/deleteLifeTimeMembershipMaster' // Delete LifeTimeMember Data (DELETE) (params => ?id=2)

//==== Get Membership Fee =======
export const GetMembershipFeeData = BaseURL + 'master/getFeeAmountByUserType' // Get Fee Data From User Type (params => ? userType=5 & birthDate=2020-05-06)

// ==== life time member Card Printing ===
export const GetLifeTimeMemberCard = BaseURL + 'system/reports/cardPrinting/generateLifeTimeMemberCard' // Get Fee Data From User Type (params => ? userId=5)

//############ TRANSACTION #############

// ===== FeeAllocation Master =====
export const GetFeeAllocationData = BaseURL + 'master/getFeeAllocationList' // Get FeeAllocation Data (GET)
export const CreateFeeAllocationData = BaseURL + 'master/saveFeeAllocation' // Create FeeAllocation Data (POST)
export const UpdateFeeAllocationData = BaseURL + 'master/updateFeeAllocation' // Update FeeAllocation Data (PUT)
export const DeleteFeeAllocationData = BaseURL + 'master/deleteFeeAllocation' // Delete FeeAllocation Data (DELETE) (params => ?id=2)

// ===== PhotoUpdate =====
export const UpdatePhotoUpdateData = BaseURL + 'user/updateLifeTimeMembershipMasterPhoto' // Update PhotoUpdate Data (PUT)

// ======= Slot Booking ========
export const AvailableSlotData = BaseURL + 'user/getSlotList' //  Available Slot Data (Get)

// ======= Card Printing ========
export const GetCardPrintingMembers = BaseURL + 'user/getPassMemberList' // Get Card Printing Members (GET)
export const GetCardPrintingData = BaseURL + 'system/reports/cardPrinting/generatePassMemberCard' //  Card Printing Data (Get)

// ======= Todays Offline Booking ========
export const GetTodayOfflineBooking = BaseURL + 'manualUser/todayManualUserList' //  Todays Offline Booking (Get)

// ======= Fee Collection (Between Date) ========
export const GetFeeCollection = BaseURL + 'payment/getFeeCollectionBetweenDate' //  Fee Collection (Get) (params => ? fromDate=2026-05-29 & toDate=2026-05-29)

// ======= Todays Online Booking ========
export const GetTodayOnlineBooking = BaseURL + 'manualUser/todayOnlineUserList' //  Todays Online Booking (Get)

// ======= Ticket Booking ========
export const GetFeeAmountData = BaseURL + 'master/getFeeAmount' //  Get Fee Amount Data for Ticket Booking(Get)
export const SaveManualUserData = BaseURL + 'manualUser/saveManualUser' //  Save Manual Use Data Data for Ticket Booking(Post)
